import * as React from "react";
import "./RocketComponent.css";
import { SvgIcon } from "./SvgIcon";
import { rocketNoData02, rocketNoData01 } from "@icons";

export interface RocketComponentProps {}

export const RocketComponent = (props: RocketComponentProps) => (
    <div className="rocket-svg">
        <SvgIcon className="rocket-svg_part1" svg={rocketNoData01} />
        <SvgIcon className="rocket-svg_part2" svg={rocketNoData02} />
        <div className="rocket-svg_text">
            Your campaign has been launched!<br />We are gathering your data,<br />try again in a bit!
        </div>
    </div>
);
